import { NavLink } from "react-router-dom";

// Barre d'actions POS : uniquement les liens déjà autorisés, sur 1 ou 2 lignes (wrap).
// Pas de menu « Plus », pas de déroulant, pas de défilement horizontal.
export default function ActionBar({ actions, dark = false }) {
  const pill = (isActive) => `inline-flex items-center gap-1.5 whitespace-nowrap shrink-0 rounded-full px-3 py-1.5 min-h-[32px] text-xs font-semibold transition-colors ${dark ? (isActive ? "bg-white text-[#0E2135]" : "bg-white/10 text-white/90 hover:bg-white/20") : (isActive ? "bg-[#2563EB] text-white shadow-sm" : "bg-[#EFF6FF] text-[#16324F] hover:bg-[#DBEAFE]")}`;
  return (
    <div className="flex flex-nowrap md:flex-wrap items-center gap-1.5 min-w-0 w-full overflow-x-auto md:overflow-visible no-scrollbar py-0.5 -my-0.5" style={{ WebkitOverflowScrolling: "touch" }} data-testid="pos-action-bar">
      {actions.map((a) => { const Icon = a.icon; return (
        <NavLink key={a.to} to={a.to} end={a.to === "/"} data-testid={`action-${a.to.replace("/", "") || "dashboard"}`} className={({ isActive }) => pill(isActive)}>
          <Icon className="w-3.5 h-3.5 shrink-0" /> {a.label}
        </NavLink>
      ); })}
    </div>
  );
}
